<template>
  <div class="a-label" :class="['a-label--' + labelState, {'a-label--compact': isCompact}]">
    <div class="a-label__tag"><p class="a-label__tag-title">{{ labelTitle }}</p></div>
    <p class="a-label__text">{{ hasText }}</p>
  </div>
</template>
<script>
export default {
  name: 'LabelTag',
  props: {
    labelState: {
      type: String,
      default: 'default'
    },
    labelTitle: {
      type: String,
      default: ''
    },
    isCompact: {
      type: Boolean,
      default: false
    },
    hasText: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// LabelTag.vue?8aafcfac